import React, { useState } from 'react'
import { HStack, InputGroup, Input, InputRightElement } from '@chakra-ui/react';
import { CiSearch } from 'react-icons/ci';
import { useTranslation } from 'react-i18next';


function SearchBox({ filters, list, setList, placeholder }) {
	const [text, setText] = useState('');
  
	const { t } = useTranslation();

	const handleSearch = (e) => {
		let value = e.target.value;

		setText(value);
		value = value.replace(/[/. -]/g, '').trim();
		if (value.length >= 3) {
			const lowerCasedValue = value.toLowerCase();

			const filteredList = list.filter((item) => {
				return filters.some((element) => {
					const itemValue = item[element].replace(/[/. -]/g, '').trim().toLowerCase();
					return itemValue.includes(lowerCasedValue);
				});
			});
			setList(filteredList);
		} else {
			setList(list);
		}
	}

  return (
		<HStack p={5} width="full" justifyContent={'center'}>
			<InputGroup size={'md'} maxW={'lg'}>
			<Input 
				boxShadow={'sm'}
				bgColor={'white'}
				borderRadius={'25px'}
				placeholder={t(placeholder)}
				_hover={{ borderColor: 'none' }}
				_focusVisible={{ borderColor: 'lightgray' }}
				value={text}
				onChange={handleSearch}
			/>

			<InputRightElement height='full' pr='16px'>
				<CiSearch />
			</InputRightElement>
			</InputGroup>
		</HStack>
  )
}

export default SearchBox;
